export default __webpack_public_path__ + "static/media/mic.6b0f300e.svg";